module.exports = __webpack_public_path__ + "static/MT_Benefit-03.730db353.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/benefit-icons/MT_Benefit-03.png
// module id = 1463
// module chunks = 169858455373905